var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 9.11765C20.1667 6.59935 19.14 4.31994 17.4827 2.67147C15.8235 1.02118 13.5318 0 11 0C8.46817 0 6.1765 1.02118 4.51733 2.67147C2.86 4.31994 1.83333 6.59935 1.83333 9.11765C1.83333 11.6359 2.86 13.9154 4.51733 15.5638C6.1765 17.2141 8.46817 18.2353 11 18.2353C13.5318 18.2353 15.8235 17.2141 17.4827 15.5638C18.3349 14.7182 19.0107 13.7134 19.4713 12.6071C19.932 11.5009 20.1683 10.315 20.1667 9.11765ZM0 27.3529C0 29.1765 4.125 31 11 31C17.4497 31 22 29.1765 22 27.3529C22 23.7059 17.6843 20.0588 11 20.0588C4.125 20.0588 0 23.7059 0 27.3529Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlack);
export default __webpack_public_path__ + "static/media/person-black.7c8db4a27e67ad5fc7bcd447e1d773b5.svg";
export { ForwardRef as ReactComponent };